import { useResponsive } from '@/hooks';
import { cn } from '@/utils';
import { TextContent } from '@/components/Text';
import { TSimulationType } from '@/types';
import { Button } from '@/components/Buttons';
import { BUTTON_LABELS } from '@/constants';
import { useState } from 'react';

interface Props {
  className?: string;
  isLoading?: boolean;
  onStartRolePlay?: () => void;
  simulationInstructions?: string;
  simulationType?: TSimulationType;
}

export const SimulationScenarioInstructions: React.FC<Props> = ({
  className,
  isLoading,
  onStartRolePlay,
  simulationInstructions,
  simulationType,
}) => {
  const [isPending, setIsPending] = useState(false);
  const isXlUp = useResponsive({ breakpoint: 'xl', direction: 'min' });

  const handleStartRolePlay = () => {
    setIsPending(true);
    onStartRolePlay?.();
  };

  return (
    <section
      className={cn('w-full max-w-6xl', className)}
      data-testid="simulation-instructions-section"
    >
      <div className="flex flex-col space-y-6">
        <TextContent
          className="whitespace-pre-line"
          isLoading={isLoading}
          label={isLoading ? ' ' : simulationInstructions}
          loadingClassName="w-full max-xl:mt-0.5"
          loadingLines={isXlUp ? 1 : 2}
          testId="simulation-instructions"
          type="paragraph"
          variant="bodyLarge"
          weight="medium"
        />

        <div>
          <Button
            className="w-auto"
            data-testid="simulation-instructions-start-button"
            disabled={isLoading}
            iconRight="ArrowRight"
            isTransitioning={isPending}
            label={BUTTON_LABELS.GET_STARTED}
            onClick={handleStartRolePlay}
            variant="primary"
          />
        </div>
      </div>
    </section>
  );
};
